import { render, staticRenderFns } from "./service-template-selection-modal.vue?vue&type=template&id=499aeef1&scoped=true"
import script from "./service-template-selection-modal.vue?vue&type=script&lang=js"
export * from "./service-template-selection-modal.vue?vue&type=script&lang=js"
import style0 from "./service-template-selection-modal.vue?vue&type=style&index=0&id=499aeef1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "499aeef1",
  null
  
)

export default component.exports